import { registerEnumType } from 'type-graphql'

export enum DocumentAssetTypeEnum {
  Order = 'Order',
  PurchaseOrder = 'PurchaseOrder',
  WorkOrder = 'WorkOrder',
  Project = 'Project',
  Task = 'Task',
  Logistic = 'Logistic',
}

registerEnumType(DocumentAssetTypeEnum, {
  name: 'DocumentAssetTypeEnum',
  description: 'Document types that support cross-domain asset attachment',
})
